import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';


const MealLibrary = ({ onClose, onSelectMeal }) => {
  const [searchQuery, setSearchQuery] = useState('');

  // Sample meal library data
  const mealLibrary = [
    {
      id: 1,
      name: 'Spaghetti Bolognese',
      category: 'Italian',
      prepTime: '30 min',
      difficulty: 'Easy',
      ingredients: ['Pasta', 'Ground beef', 'Tomato sauce', 'Onion', 'Garlic']
    },
    {
      id: 2,
      name: 'Chicken Stir Fry',
      category: 'Asian',
      prepTime: '20 min',
      difficulty: 'Easy',
      ingredients: ['Chicken breast', 'Mixed vegetables', 'Soy sauce', 'Rice']
    },
    {
      id: 3,
      name: 'Caesar Salad',
      category: 'Salad',
      prepTime: '15 min',
      difficulty: 'Easy',
      ingredients: ['Romaine lettuce', 'Caesar dressing', 'Croutons', 'Parmesan']
    },
    {
      id: 4,
      name: 'Beef Tacos',
      category: 'Mexican',
      prepTime: '25 min',
      difficulty: 'Easy',
      ingredients: ['Ground beef', 'Taco shells', 'Lettuce', 'Cheese', 'Salsa']
    },
    {
      id: 5,
      name: 'Grilled Salmon',
      category: 'Seafood',
      prepTime: '20 min',
      difficulty: 'Medium',
      ingredients: ['Salmon fillet', 'Lemon', 'Herbs', 'Olive oil']
    },
    {
      id: 6,
      name: 'Vegetable Curry',
      category: 'Indian',
      prepTime: '35 min',
      difficulty: 'Medium',
      ingredients: ['Mixed vegetables', 'Curry paste', 'Coconut milk', 'Rice']
    }
  ];

  const filteredMeals = mealLibrary?.filter(meal =>
    meal?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    meal?.category?.toLowerCase()?.includes(searchQuery?.toLowerCase())
  );

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-card border border-border rounded-lg max-w-4xl w-full max-h-[80vh] flex flex-col">
        {/* Header */}
        <div className="p-6 border-b border-border">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-2xl font-semibold text-foreground">Meal Library</h2>
            <button
              onClick={onClose}
              className="p-2 hover:bg-muted rounded-lg transition-colors"
            >
              <Icon name="x" size={24} className="text-muted-foreground" />
            </button>
          </div>
          
          {/* Search */}
          <div className="relative">
            <Icon
              name="search"
              size={20}
              className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground"
            />
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e?.target?.value)}
              placeholder="Search meals..."
              className="w-full pl-10 pr-4 py-2 border border-input rounded-md bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary"
            />
          </div>
        </div>

        {/* Meal Grid */}
        <div className="flex-1 overflow-y-auto p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {filteredMeals?.map(meal => (
              <div
                key={meal?.id}
                className="bg-muted border border-border rounded-lg p-4 hover:bg-muted/80 transition-colors cursor-pointer"
                onClick={() => onSelectMeal(meal)}
              >
                <div className="flex items-start justify-between mb-3">
                  <h3 className="font-semibold text-foreground">{meal?.name}</h3>
                  <span className="text-xs px-2 py-1 bg-primary/10 text-primary rounded-full">
                    {meal?.category}
                  </span>
                </div>
                
                <div className="flex items-center gap-4 text-sm text-muted-foreground mb-3">
                  <div className="flex items-center gap-1">
                    <Icon name="clock" size={14} />
                    <span>{meal?.prepTime}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Icon name="chef-hat" size={14} />
                    <span>{meal?.difficulty}</span>
                  </div>
                </div>

                <div>
                  <p className="text-xs text-muted-foreground mb-1">Ingredients:</p>
                  <div className="flex flex-wrap gap-1">
                    {meal?.ingredients?.slice(0, 3)?.map((ingredient, idx) => (
                      <span
                        key={idx}
                        className="text-xs px-2 py-0.5 bg-background rounded-full text-foreground"
                      >
                        {ingredient}
                      </span>
                    ))}
                    {meal?.ingredients?.length > 3 && (
                      <span className="text-xs px-2 py-0.5 text-muted-foreground">
                        +{meal?.ingredients?.length - 3} more
                      </span>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {filteredMeals?.length === 0 && (
            <div className="text-center py-12">
              <Icon name="search" size={48} className="mx-auto mb-4 text-muted-foreground" />
              <p className="text-muted-foreground">No meals found matching your search.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MealLibrary;